import React from "react";
import styled from "styled-components";
import cuideoTheme from "../../containers/themes/defaultTheme";
import {
  Dialog,
  Typography,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
} from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import Transition from "./Transition";

const StyledErrorModal = styled(Dialog)`
  .MuiPaper-root {
    max-width: 20rem;
    color: ${cuideoTheme.palette.error.contrastText};
    background-color: ${cuideoTheme.palette.error.dark};
  }
`;

const StyledDialogTitle = styled(DialogTitle)`
  .MuiTypography-root {
    color: ${cuideoTheme.palette.error.contrastText};
    font-size: 1.25rem;
  }
`;

const StyledModalText = styled(Typography)`
  line-height: normal;
`;

const StyledModalActions = styled(DialogActions)`
  justify-content: center;
  margin: 0.5rem 0;
`;

const FixedErrorModal = (props: any) => {
  const { modal, handleDialogClose } = props;

  return (
    <StyledErrorModal
      open={modal.open}
      TransitionComponent={Transition as any}
      keepMounted
      onClose={handleDialogClose}
    >
      <StyledDialogTitle>
        <FormattedMessage id="ErrorModal.Error" defaultMessage="Error" />
      </StyledDialogTitle>
      <DialogContent>
        {modal.message === "unauthorized" ? (
          <StyledModalText>
            <FormattedMessage
              id="ErrorModal.errorUnauthorized"
              defaultMessage="Parece que tu sesión ha terminado. Por favor, vuelve a conectarte."
            />
          </StyledModalText>
        ) : (
          <StyledModalText color="primary">
            <FormattedMessage id="ErrorModal.error" defaultMessage="Error" />
          </StyledModalText>
        )}
      </DialogContent>
      <StyledModalActions>
        <Button
          variant="outlined"
          color="inherit"
          onClick={() => {
            handleDialogClose();
          }}
        >
          <FormattedMessage id="ErrorModal.Accept" defaultMessage="Entendido" />
        </Button>
      </StyledModalActions>
    </StyledErrorModal>
  );
};

export default FixedErrorModal;
